import { intercept, toJS } from 'mobx';
import { inject, observer } from 'mobx-react';
import * as React from 'react';
import { Prompt, withRouter } from 'react-router-dom';
import { Button, Col, Form, FormGroup, Label, Row } from 'reactstrap';
import { EButton, EInput } from 'src/Components/EInput';
import WellFooter from 'src/Components/Footer/WellFooter';
import { IWell } from '../../../../Interfaces/WellInterface';
import ButtonRow from '../../../ButtonRow';
import WorkflowHeader from '../../WorkflowHeader';
import WellCloseButton from '../WellCloseButton';
import WellRevertCloseButton from "../WellRevertCloseButton";





interface IParams {
    wellId: number | string;
}

@inject('stores')
@observer
class WellLocation extends React.Component {
    public props: any;
    public params: IParams;
    private WellsStore: any;
    private well: IWell = new IWell();

    // disposers
    public wellDisposer: any;

    public state = {
        bhlisLabour: false,
        isDirty: false,
        shlisLabour: false,
        well: this.well,
        wellPageTitle: 'New Well',
    };

    constructor(props: any) {
        super(props);

        this.WellsStore = this.props.stores.WellsStore;
        this.params = this.props.match.params;

        this.handleInputChange = this.handleInputChange.bind(this);
        this.updateisLabour = this.updateisLabour.bind(this);
        this.updateWellModel = this.updateWellModel.bind(this);

    }

    public componentDidMount() {
        
        this.createDisposers();

        if (this.props.stores.WellsStore.well) {
            this.setState({
                well: this.props.stores.WellsStore.well
            });
        } else {
            this.WellsStore.getWellDetails(this.params.wellId);
        }

    }

    public componentWillUnmount() {
        this.wellDisposer();
    }

    public createDisposers() {
        this.wellDisposer = intercept(this.WellsStore, 'well', (change: any) => {
            this.setState({
                well: toJS(change.newValue),
                wellPageTitle: change.newValue.wellName
            });
            return change;
        });
    }

    private handleInputChange(event: any) {
        const well = this.state.well;

        well[event.target.name] = event.target.value;

        this.setState({
            isDirty: true,
            well
        });
    }

    private updateisLabour(event: any) {
        const well = this.state.well;
        const labour = event.target.value;
        well[event.target.name] = (labour === 'true');

        this.setState({
            [event.target.name]: (labour === 'true'),
            isDirty: true,
            well
        });
    }

    private updateWellModel() {
        this.WellsStore.updateWellModel(this.state.well)
            .then(
                (data: any) => {
                    if ( data ) {
                        this.setState({
                            isDirty: false,
                        });
                    }
                }
            );
    }

    private buttonNavigation = (event: any) => {
        const $target = event.target;
        if ( $target.name === 'previousButton' ) {
            this.props.history.push('/well/' + this.params.wellId + '/details');
        } else {
            this.props.history.push('/well/' + this.params.wellId + '/contacts');
        }
    }

    public render() {
        return(
            <div className="WellLocation">
                <Prompt when={this.state.isDirty} message={"Changes have been made.\n\nPress Cancel then Press Save OR Press OK to continue without saving."} />
                <WorkflowHeader wellSetupComplete={this.state.well.wellSetupComplete} workflowHeaderItems={this.props.workflowHeaderItems}/>
                <Form>
                    <Row>
                        <Col md="12">
                            <FormGroup>
                                <Label>Field/Area/Unit</Label>
                                <EInput
                                    type="text"
                                    name="fieldAreaUnit"
                                    id="fieldAreaUnit"
                                    onChange={this.handleInputChange}
                                    value={this.state.well.fieldAreaUnit}
                                />
                            </FormGroup>
                        </Col>
                    </Row>
                    <Row>
                        <Col md="12">
                            <h5>Well GPS Coordinates (NAD 27)</h5>
                        </Col>
                        <Col md="6">
                            <FormGroup>
                                <Label>Latitude - SHL</Label>
                                <EInput
                                    type="text"
                                    name="shlgpsLatitude"
                                    id="shlgpsLatitude"
                                    onChange={this.handleInputChange}
                                    value={this.state.well.shlgpsLatitude}
                                />
                            </FormGroup>
                        </Col>
                        <Col md="6">
                            <FormGroup>
                                <Label>Longitude - SHL</Label>
                                <EInput
                                    type="text"
                                    name="shlgpsLongitude"
                                    id="shlgpsLongitude"
                                    onChange={this.handleInputChange}
                                    value={this.state.well.shlgpsLongitude}
                                />
                            </FormGroup>
                        </Col>
                        { this.state.well.wellType !== 'Vertical' ?
                            <Col md="6">
                                <FormGroup>
                                    <Label>Latitude - BHL</Label>
                                    <EInput
                                        type="text"
                                        name="bhlgpsLatitude"
                                        id="bhlgpsLatitude"
                                        onChange={this.handleInputChange}
                                        value={this.state.well.bhlgpsLatitude}
                                    />
                                </FormGroup>
                            </Col> : null
                        }
                        { this.state.well.wellType !== 'Vertical' ?
                            <Col md="6">
                                <FormGroup>
                                    <Label>Longitude - BHL</Label>
                                    <EInput
                                        type="text"
                                        name="bhlgpsLongitude"
                                        id="bhlgpsLongitude"
                                        onChange={this.handleInputChange}
                                        value={this.state.well.bhlgpsLongitude}
                                    />
                                </FormGroup>
                            </Col> : null
                        }
                    </Row>

                    { this.state.well.state !== "TX" ?
                        <div>
                            <Row>
                                <Col md="12">
                                    <h5>Well Legal - SHL</h5>
                                </Col>
                                <Col md="4">
                                    <FormGroup>
                                        <Label>Section</Label>
                                        <EInput
                                            type="text"
                                            name="shlSection"
                                            id="shlSection"
                                            onChange={this.handleInputChange}
                                            value={this.state.well.shlSection}
                                        />
                                    </FormGroup>
                                </Col>
                                <Col md="4">
                                    <Row>
                                        <Col md="6">
                                            <FormGroup>
                                                <Label>Township</Label>
                                                <EInput
                                                    type="text"
                                                    data-type="text"
                                                    name="shlTownship"
                                                    id="shlTownship"
                                                    onChange={this.handleInputChange}
                                                    value={this.state.well.shlTownship}
                                                />
                                            </FormGroup>
                                        </Col>
                                        <Col md="6">
                                            <FormGroup>
                                                <Label>North/South</Label>
                                                <EInput
                                                    type="select"
                                                    name="shlTownshipDirection"
                                                    id="shlTownshipDirection"
                                                    value={this.state.well.shlTownshipDirection}
                                                    onChange={this.handleInputChange}
                                                >
                                                    <option selected={true} />
                                                    <option value="N">North</option>
                                                    <option value="S">South</option>
                                                </EInput>
                                            </FormGroup>
                                        </Col>
                                    </Row>
                                </Col>
                                <Col md="4">
                                    <Row>
                                        <Col md="6">
                                            <FormGroup>
                                                <Label>Range</Label>
                                                <EInput
                                                    type="text"
                                                    name="shlRange"
                                                    id="shlRange"
                                                    onChange={this.handleInputChange}
                                                    value={this.state.well.shlRange}
                                                />
                                            </FormGroup>
                                        </Col>
                                        <Col md="6">
                                            <FormGroup>
                                                <Label>East/West</Label>
                                                <EInput
                                                    type="select"
                                                    name="shlRangeDirection"
                                                    id="shlRangeDirection"
                                                    value={this.state.well.shlRangeDirection}
                                                    onChange={this.handleInputChange}
                                                >
                                                    <option selected={true} />
                                                    <option value="E">East</option>
                                                    <option value="W">West</option>
                                                </EInput>
                                            </FormGroup>
                                        </Col>
                                    </Row>
                                </Col>
                                <Col md="3">
                                    <FormGroup>
                                        <Label>From Point</Label>
                                        <EInput
                                            type="select"
                                            name="shlFromPointNS"
                                            id="shlFromPointNS"
                                            value={this.state.well.shlFromPointNS}
                                            onChange={this.handleInputChange}
                                        >
                                            <option />
                                            <option value="North">North</option>
                                            <option value="South">South</option>
                                        </EInput>
                                    </FormGroup>
                                </Col>
                                <Col md="3">
                                    <FormGroup>
                                        <Label/>
                                        <EInput
                                            type="text"
                                            name="shlFromPointNSDistance"
                                            id="shlFromPointNSDistance"
                                            onChange={this.handleInputChange}
                                            value={this.state.well.shlFromPointNSDistance}
                                        />
                                    </FormGroup>
                                </Col>
                                <Col md="3">
                                    <FormGroup>
                                        <Label/>
                                        <EInput
                                            type="select"
                                            name="shlFromPointEW"
                                            id="shlFromPointEW"
                                            value={this.state.well.shlFromPointEW}
                                            onChange={this.handleInputChange}
                                        >
                                            <option />
                                            <option value="East">East</option>
                                            <option value="West">West</option>
                                        </EInput>
                                    </FormGroup>
                                </Col>
                                <Col md="3">
                                    <FormGroup>
                                        <Label/>
                                        <EInput
                                            type="text"
                                            name="shlFromPointEWDistance"
                                            id="shlFromPointEWDistance"
                                            onChange={this.handleInputChange}
                                            value={this.state.well.shlFromPointEWDistance}
                                        />
                                    </FormGroup>
                                </Col>
                            </Row>
                            { this.state.well.wellType !== 'Vertical' ?
                                <Row>
                                    <Col md="12">
                                        <h5>Well Legal - BHL</h5>
                                    </Col>
                                    <Col md="4">
                                        <FormGroup>
                                            <Label>Section</Label>
                                            <EInput
                                                type="text"
                                                name="bhlSection"
                                                id="bhlSection"
                                                onChange={this.handleInputChange}
                                                value={this.state.well.bhlSection}
                                            />
                                        </FormGroup>
                                    </Col>
                                    <Col md="4">
                                        <Row>
                                            <Col md="6">
                                                <FormGroup>
                                                    <Label>Township</Label>
                                                    <EInput
                                                        type="text"
                                                        name="bhlTownship"
                                                        id="bhlTownship"
                                                        onChange={this.handleInputChange}
                                                        value={this.state.well.bhlTownship}
                                                        />
                                                </FormGroup>
                                            </Col>
                                            <Col md="6">
                                                <FormGroup>
                                                    <Label>North/South</Label>
                                                    <EInput
                                                        type="select"
                                                        name="bhlTownshipDirection"
                                                        id="bhlTownshipDirection"
                                                        value={this.state.well.bhlTownshipDirection}
                                                        onChange={this.handleInputChange}
                                                    >
                                                        <option selected={true} />
                                                        <option value="N">North</option>
                                                        <option value="S">South</option>
                                                    </EInput>
                                                </FormGroup>
                                            </Col>
                                        </Row>
                                    </Col>
                                    <Col md="4">
                                        <Row>
                                            <Col md="6">
                                                <FormGroup>
                                                    <Label>Range</Label>
                                                    <EInput
                                                        type="text"
                                                        name="bhlRange"
                                                        id="bhlRange"
                                                        onChange={this.handleInputChange}
                                                        value={this.state.well.bhlRange}
                                                    />
                                                </FormGroup>
                                            </Col>
                                            <Col md="6">
                                                <FormGroup>
                                                    <Label>East/West</Label>
                                                    <EInput
                                                        type="select"
                                                        name="bhlRangeDirection"
                                                        id="bhlRangeDirection"
                                                        value={this.state.well.bhlRangeDirection}
                                                        onChange={this.handleInputChange}
                                                    >
                                                        <option selected={true} />
                                                        <option value="E">East</option>
                                                        <option value="W">West</option>
                                                    </EInput>
                                                </FormGroup>
                                            </Col>
                                        </Row>
                                    </Col>
                                    <Col md="3">
                                        <FormGroup>
                                            <Label>From Point</Label>
                                            <EInput
                                                type="select"
                                                name="bhlFromPointNS"
                                                id="bhlFromPointNS"
                                                value={this.state.well.bhlFromPointNS}
                                                onChange={this.handleInputChange}
                                            >
                                                <option />
                                                <option value="North">North</option>
                                                <option value="South">South</option>
                                            </EInput>
                                        </FormGroup>
                                    </Col>
                                    <Col md="3">
                                        <FormGroup>
                                            <Label/>
                                            <EInput
                                                type="text"
                                                name="bhlFromPointNSDistance"
                                                id="bhlFromPointNSDistance"
                                                onChange={this.handleInputChange}
                                                value={this.state.well.bhlFromPointNSDistance}
                                            />
                                        </FormGroup>
                                    </Col>
                                    <Col md="3">
                                        <FormGroup>
                                            <Label/>
                                            <EInput
                                                type="select"
                                                name="bhlFromPointEW"
                                                id="bhlFromPointEW"
                                                value={this.state.well.bhlFromPointEW}
                                                onChange={this.handleInputChange}
                                            >
                                                <option />
                                                <option value="East">East</option>
                                                <option value="West">West</option>
                                            </EInput>
                                        </FormGroup>
                                    </Col>
                                    <Col md="3">
                                        <FormGroup>
                                            <Label/>
                                            <EInput
                                                type="text"
                                                name="bhlFromPointEWDistance"
                                                id="bhlFromPointEWDistance"
                                                onChange={this.handleInputChange}
                                                value={this.state.well.bhlFromPointEWDistance}
                                            />
                                        </FormGroup>
                                    </Col>
                                </Row> : null
                            }
                        </div> :
                        <div>
                            <Row>
                                <Col md="12">
                                    <h5>Well Legal - SHL</h5>
                                </Col>
                                <Col md="12">
                                    <FormGroup check={true}>
                                        <Label check={true}>
                                            <EInput
                                                type="radio"
                                                name="shlisLabour"
                                                id="shlisLabour"
                                                value="false"
                                                onChange={this.updateisLabour}
                                                checked={this.state.well.shlisLabour === false}
                                            />
                                            Section
                                        </Label>
                                    </FormGroup>
                                    <FormGroup check={true}>
                                        <Label check={true}>
                                            <EInput
                                                type="radio"
                                                name="shlisLabour"
                                                id="shlisLabour"
                                                value="true"
                                                onChange={this.updateisLabour}
                                                checked = {this.state.well.shlisLabour === true}
                                            />
                                            Labour
                                        </Label>
                                    </FormGroup>
                                </Col>
                                <Col md="3">
                                    <FormGroup>
                                        <Label>Section</Label>
                                        <EInput
                                            type="text"
                                            name="shlSection"
                                            id="shlSection"
                                            onChange={this.handleInputChange}
                                            disabled={this.state.well.shlisLabour === true}
                                            value={this.state.well.shlSection}
                                        />
                                    </FormGroup>
                                </Col>
                                <Col md="3">
                                    <Row>
                                        <Col md="6">
                                            <FormGroup>
                                                <Label>Block</Label>
                                                <EInput
                                                    type="text"
                                                    name="shlBlock"
                                                    id="shlBlock"
                                                    onChange={this.handleInputChange}
                                                    disabled={this.state.well.shlisLabour === true}
                                                    value={this.state.well.shlBlock}
                                                />
                                            </FormGroup>
                                        </Col>
                                        <Col md="6">
                                            <FormGroup>
                                                <Label>East/West</Label>
                                                <EInput
                                                    type="select"
                                                    name="shlBlockDirection"
                                                    id="shlBlockDirection"
                                                    disabled={this.state.well.shlisLabour === true}
                                                    value={this.state.well.shlBlockDirection}
                                                    onChange={this.handleInputChange}
                                                >
                                                    <option selected={true}/>
                                                    <option value="E">East</option>
                                                    <option value="W">West</option>
                                                </EInput>
                                            </FormGroup>
                                        </Col>
                                    </Row>
                                </Col>
                                <Col md="3">
                                    <Row>
                                        <Col md="6">
                                            <FormGroup>
                                                <Label>Township</Label>
                                                <EInput
                                                    type="text"
                                                    name="shlTownship"
                                                    id="shlTownship"
                                                    onChange={this.handleInputChange}
                                                    disabled={this.state.well.shlisLabour === true}
                                                    value={this.state.well.shlTownship}
                                                />
                                            </FormGroup>
                                        </Col>
                                        <Col md="6">
                                            <FormGroup>
                                                <Label>North/South</Label>
                                                <EInput
                                                    type="select"
                                                    name="shlTownshipDirection"
                                                    id="shlTownshipDirection"
                                                    disabled={this.state.well.shlisLabour === true}
                                                    value={this.state.well.shlTownshipDirection}
                                                    onChange={this.handleInputChange}
                                                >
                                                    <option selected={true} />
                                                    <option value="N">North</option>
                                                    <option value="S">South</option>
                                                </EInput>
                                            </FormGroup>
                                        </Col>
                                    </Row>
                                </Col>
                                <Col md="3">
                                    <FormGroup>
                                        <Label>Abstract</Label>
                                        <EInput
                                            type="text"
                                            name="shlAbstract"
                                            id="shlAbstract"
                                            onChange={this.handleInputChange}
                                            disabled={this.state.well.shlisLabour === true}
                                            value={this.state.well.shlAbstract}
                                        />
                                    </FormGroup>
                                </Col>
                                <Col md="3">
                                    <FormGroup>
                                        <Label>Labour</Label>
                                        <EInput
                                            type="text"
                                            name="shlLabour"
                                            id="shlLabour"
                                            onChange={this.handleInputChange}
                                            disabled={this.state.well.shlisLabour === false}
                                            value={this.state.well.shlLabour}
                                        />
                                    </FormGroup>
                                </Col>
                                <Col md="3">
                                    <FormGroup>
                                        <Label>League</Label>
                                        <EInput
                                            type="text"
                                            name="shlLeague"
                                            id="shlLeague"
                                            onChange={this.handleInputChange}
                                            disabled={this.state.well.shlisLabour === false}
                                            value={this.state.well.shlLeague}
                                        />
                                    </FormGroup>
                                </Col>
                                <Col md="3">
                                    <FormGroup>
                                        <Label>Survey</Label>
                                        <EInput
                                            type="text"
                                            name="shlSurvey"
                                            id="shlSurvey"
                                            onChange={this.handleInputChange}
                                            value={this.state.well.shlSurvey}
                                        />
                                    </FormGroup>
                                </Col>
                                <div className="w-100"/>
                                <Col md="3">
                                    <FormGroup>
                                        <Label>From Point</Label>
                                        <EInput
                                            type="select"
                                            name="shlFromPointNS"
                                            id="shlFromPointNS"
                                            value={this.state.well.shlFromPointNS}
                                            onChange={this.handleInputChange}
                                        >
                                            <option />
                                            <option value="North">North</option>
                                            <option value="South">South</option>
                                            <option value="North West">North West</option>
                                            <option value="North East">North East</option>
                                        </EInput>
                                    </FormGroup>
                                </Col>
                                <Col md="3">
                                    <FormGroup>
                                        <Label/>
                                        <EInput
                                            type="text"
                                            name="shlFromPointNSDistance"
                                            id="shlFromPointNSDistance"
                                            onChange={this.handleInputChange}
                                            value={this.state.well.shlFromPointNSDistance}
                                        />
                                    </FormGroup>
                                </Col>
                                <Col md="3">
                                    <FormGroup>
                                        <Label/>
                                        <EInput
                                            type="select"
                                            name="shlFromPointEW"
                                            id="shlFromPointEW"
                                            value={this.state.well.shlFromPointEW}
                                            onChange={this.handleInputChange}
                                        >
                                            <option />
                                            <option value="East">East</option>
                                            <option value="West">West</option>
                                            <option value="South East">South East</option>
                                            <option value="South West">South West</option>
                                        </EInput>
                                    </FormGroup>
                                </Col>
                                <Col md="3">
                                    <FormGroup>
                                        <Label/>
                                        <EInput
                                            type="text"
                                            name="shlFromPointEWDistance"
                                            id="shlFromPointEWDistance"
                                            onChange={this.handleInputChange}
                                            value={this.state.well.shlFromPointEWDistance}
                                        />
                                    </FormGroup>
                                </Col>
                            </Row>
                            { this.state.well.wellType !== 'Vertical' ?
                                <Row>
                                    <Col md="12">
                                        <h5>Well Legal - BHL</h5>
                                    </Col>
                                    <Col md="12">
                                        <FormGroup check={true}>
                                            <Label check={true}>
                                                <EInput
                                                    type="radio"
                                                    name="bhlisLabour"
                                                    id="bhlisLabour"
                                                    value="false"
                                                    onChange={this.updateisLabour}
                                                    checked={this.state.well.bhlisLabour === false}
                                                />
                                                Section
                                            </Label>
                                        </FormGroup>
                                        <FormGroup check={true}>
                                            <Label check={true}>
                                                <EInput
                                                    type="radio"
                                                    name="bhlisLabour"
                                                    id="bhlisLabour"
                                                    value="true"
                                                    onChange={this.updateisLabour}
                                                    checked={this.state.well.bhlisLabour === true}
                                                />
                                                Labour
                                            </Label>
                                        </FormGroup>
                                    </Col>
                                    <Col md="3">
                                        <FormGroup>
                                            <Label>Section</Label>
                                            <EInput
                                                type="text"
                                                name="bhlSection"
                                                id="bhlSection"
                                                onChange={this.handleInputChange}
                                                disabled={this.state.well.bhlisLabour === true}
                                                value={this.state.well.bhlSection}
                                            />
                                        </FormGroup>
                                    </Col>
                                    <Col md="3">
                                        <Row>
                                            <Col md="6">
                                                <FormGroup>
                                                    <Label>Block</Label>
                                                    <EInput
                                                        type="text"
                                                        name="bhlBlock"
                                                        id="bhlBlock"
                                                        onChange={this.handleInputChange}
                                                        disabled={this.state.well.bhlisLabour === true}
                                                        value={this.state.well.bhlBlock}
                                                        />
                                                </FormGroup>
                                            </Col>
                                            <Col md="6">
                                                <FormGroup>
                                                    <Label>East/West</Label>
                                                    <EInput
                                                        type="select"
                                                        name="bhlBlockDirection"
                                                        id="bhlBlockDirection"
                                                        onChange={this.handleInputChange}
                                                        disabled={this.state.well.bhlisLabour === true}
                                                        value={this.state.well.bhlBlockDirection}
                                                    >                              
                                                        <option selected={true}/>
                                                        <option value="E">East</option>
                                                        <option value="W">West</option>
                                                    </EInput>
                                                </FormGroup>
                                            </Col>
                                        </Row>
                                    </Col>
                                    <Col md="3">
                                    <Row>
                                        <Col md="6">
                                            <FormGroup>
                                                <Label>Township</Label>
                                                <EInput
                                                    type="text"
                                                    name="bhlTownship"
                                                    id="bhlTownship"
                                                    onChange={this.handleInputChange}
                                                    disabled={this.state.well.bhlisLabour === true}
                                                    value={this.state.well.bhlTownship}
                                                    />
                                            </FormGroup>
                                        </Col>
                                        <Col md="6">
                                            <FormGroup>
                                                <Label>North/South</Label>
                                                <EInput
                                                    type="select"
                                                    name="bhlTownshipDirection"
                                                    id="bhlTownshipDirection"
                                                    onChange={this.handleInputChange}
                                                    disabled={this.state.well.bhlisLabour === true}
                                                    value={this.state.well.bhlTownshipDirection}
                                                >                              
                                                    <option selected={true}/>
                                                    <option value="N">North</option>
                                                    <option value="S">South</option>
                                                </EInput>
                                            </FormGroup>
                                        </Col>
                                    </Row>
                                    </Col>
                                    <Col md="3">
                                        <FormGroup>
                                            <Label>Abstract</Label>
                                            <EInput
                                                type="text"
                                                name="bhlAbstract"
                                                id="bhlAbstract"
                                                onChange={this.handleInputChange}
                                                disabled={this.state.well.bhlisLabour === true}
                                                value={this.state.well.bhlAbstract}
                                            />
                                        </FormGroup>
                                    </Col>
                                    <Col md="3">
                                        <FormGroup>
                                            <Label>Labour</Label>
                                            <EInput
                                                type="text"
                                                name="bhlLabour"
                                                id="bhlLabour"
                                                onChange={this.handleInputChange}
                                                disabled={this.state.well.bhlisLabour === false}
                                                value={this.state.well.bhlLabour}
                                            />
                                        </FormGroup>
                                    </Col>
                                    <Col md="3">
                                        <FormGroup>
                                            <Label>League</Label>
                                            <EInput
                                                type="text"
                                                name="bhlLeague"
                                                id="bhlLeague"
                                                onChange={this.handleInputChange}
                                                disabled={this.state.well.bhlisLabour === false}
                                                value={this.state.well.bhlLeague}
                                            />
                                        </FormGroup>
                                    </Col>
                                    <Col md="3">
                                        <FormGroup>
                                            <Label>Survey</Label>
                                            <EInput
                                                type="text"
                                                name="bhlSurvey"
                                                id="bhlSurvey"
                                                onChange={this.handleInputChange}
                                                value={this.state.well.bhlSurvey}
                                            />
                                        </FormGroup>
                                    </Col>
                                    <div className="w-100"/>
                                    <Col md="3">
                                        <FormGroup>
                                            <Label>From Point</Label>
                                            <EInput
                                                type="select"
                                                name="bhlFromPointNS"
                                                id="bhlFromPointNS"
                                                value={this.state.well.bhlFromPointNS}
                                                onChange={this.handleInputChange}
                                            >
                                                <option />
                                                <option value="North">North</option>
                                                <option value="South">South</option>
                                                <option value="North West">North West</option>
                                                <option value="North East">North East</option>
                                            </EInput>
                                        </FormGroup>
                                    </Col>
                                    <Col md="3">
                                        <FormGroup>
                                            <Label/>
                                            <EInput
                                                type="text"
                                                name="bhlFromPointNSDistance"
                                                id="bhlFromPointNSDistance"
                                                onChange={this.handleInputChange}
                                                value={this.state.well.bhlFromPointNSDistance}
                                            />
                                        </FormGroup>
                                    </Col>
                                    <Col md="3">
                                        <FormGroup>
                                            <Label/>
                                            <EInput
                                                type="select"
                                                name="bhlFromPointEW"
                                                id="bhlFromPointEW"
                                                value={this.state.well.bhlFromPointEW}
                                                onChange={this.handleInputChange}
                                            >
                                                <option />
                                                <option value="East">East</option>
                                                <option value="West">West</option>
                                                <option value="South East">South East</option>
                                                <option value="South West">South West</option>
                                            </EInput>
                                        </FormGroup>
                                    </Col>
                                    <Col md="3">
                                        <FormGroup>
                                            <Label/>
                                            <EInput
                                                type="text"
                                                name="bhlFromPointEWDistance"
                                                id="bhlFromPointEWDistance"
                                                onChange={this.handleInputChange}
                                                value={this.state.well.bhlFromPointEWDistance}
                                            />
                                        </FormGroup>
                                    </Col>
                                </Row> : null
                            }
                        </div>
                    }
                    <ButtonRow>
                        <WellRevertCloseButton />
                        { <WellCloseButton />}
                        <Button className="secondary" name="previousButton" onClick={this.buttonNavigation}>Previous</Button>
                        { this.WellsStore.canUpdateWell() && <EButton color="primary" name="save" onClick={this.updateWellModel}>Save</EButton>}
                        <Button className="secondary" name="nextButton" onClick={this.buttonNavigation}>Next</Button>
                        <WellFooter />
                    </ButtonRow>
                </Form>
            </div>
        );
    }
}

export default withRouter(WellLocation);



// WEBPACK FOOTER //
// ./src/Components/Main/WellWorkflow/WellLocation/WellLocation.tsx